function isAlphanumericValidatorUtil (string) {
  const re = /^[a-z0-9]+$/i
  return re.test(String(string).toLowerCase())
}

export {
  isAlphanumericValidatorUtil
}
